// extracted by mini-css-extract-plugin
export default {"dropdown":"_2UMTl","portal":"_14SXZ","sportInfo":"_3JYKJ","sportIcon":"_2V-jx","sportIconSingleValue":"_2u427","topMatch":"_3so4b","sportType":"_3K-V0"};